import React from "react";

import SpLink from "../../../shared/SpLink";

import styles from "./PollenLogo.module.scss";

type PollenLogoType = {
  className?: string;
};

const PollenLogo: React.FC<PollenLogoType> = ({ className }) => (
  <SpLink
    path="/pollen/"
    className={styles.pollenLogoLink}
    data-testid="nav-single-logo"
  >
    <div className={`${styles.pollenLogo} ${className}`}>
      <img alt="pollen logo" src="/images/pollen-logo.png" />
    </div>
  </SpLink>
);

export default PollenLogo;
